export enum SessionEventsRoutes {
  CreateOne = 'create-one',
  ExportShots = 'export-shots',
  GetFireByID = 'get-fire-by-id',
  GetLogin = 'get-login',
  GetManyFromSession = 'get-many-from-session',
  RecentRecaps = 'recent-recaps',
  SummarizeMachines = 'summarize-machines',
  SummarizeUser = 'summarize-user',
  UpdateOne = 'update-one',
}
